import * as MutationHelpers from 'shared/helpers/vuex/mutationHelpers';
import types from '../mutation-types';
import KnowledgeBaseDocumentsAPI from '../../api/knowledgeBaseDocuments';
import { throwErrorMessage } from '../utils/api';

export const state = {
  records: [],
  uiFlags: {
    isFetching: false,
    isCreating: false,
    isDeleting: false,
  },
};

export const getters = {
  getKnowledgeBaseDocuments($state) {
    return $state.records;
  },
  getUIFlags($state) {
    return $state.uiFlags;
  },
};

export const actions = {
  index: async ({ commit }, agentBotId) => {
    commit(types.SET_KNOWLEDGE_BASE_DOCUMENT_UI_FLAG, { isFetching: true });
    try {
      const response = await KnowledgeBaseDocumentsAPI.index(agentBotId);
      commit(types.SET_KNOWLEDGE_BASE_DOCUMENTS, response.data);
      return response.data;
    } catch (error) {
      throwErrorMessage(error);
      return null;
    } finally {
      commit(types.SET_KNOWLEDGE_BASE_DOCUMENT_UI_FLAG, { isFetching: false });
    }
  },

  createFromFile: async ({ commit }, { agentBotId, file, name }) => {
    commit(types.SET_KNOWLEDGE_BASE_DOCUMENT_UI_FLAG, { isCreating: true });
    try {
      const response = await KnowledgeBaseDocumentsAPI.createFromFile(
        agentBotId,
        { file, name }
      );
      commit(types.ADD_KNOWLEDGE_BASE_DOCUMENT, response.data);
      return response.data;
    } catch (error) {
      throwErrorMessage(error);
      return null;
    } finally {
      commit(types.SET_KNOWLEDGE_BASE_DOCUMENT_UI_FLAG, { isCreating: false });
    }
  },

  createFromText: async ({ commit }, { agentBotId, name, content }) => {
    commit(types.SET_KNOWLEDGE_BASE_DOCUMENT_UI_FLAG, { isCreating: true });
    try {
      const response = await KnowledgeBaseDocumentsAPI.createFromText(
        agentBotId,
        { name, content }
      );
      commit(types.ADD_KNOWLEDGE_BASE_DOCUMENT, response.data);
      return response.data;
    } catch (error) {
      throwErrorMessage(error);
      return null;
    } finally {
      commit(types.SET_KNOWLEDGE_BASE_DOCUMENT_UI_FLAG, { isCreating: false });
    }
  },

  delete: async ({ commit }, { agentBotId, id }) => {
    commit(types.SET_KNOWLEDGE_BASE_DOCUMENT_UI_FLAG, { isDeleting: true });
    try {
      await KnowledgeBaseDocumentsAPI.delete(agentBotId, id);
      commit(types.DELETE_KNOWLEDGE_BASE_DOCUMENT, id);
    } catch (error) {
      throwErrorMessage(error);
    } finally {
      commit(types.SET_KNOWLEDGE_BASE_DOCUMENT_UI_FLAG, { isDeleting: false });
    }
  },

  approve: async ({ dispatch, commit }, { agentBotId, id }) => {
    commit(types.SET_KNOWLEDGE_BASE_DOCUMENT_UI_FLAG, { isApproving: true });
    try {
      await KnowledgeBaseDocumentsAPI.approve(agentBotId, id);
      // The doc transitions pending_review -> pending -> processing -> ready;
      // re-fetch rather than track each hop.
      await dispatch('index', agentBotId);
    } catch (error) {
      throwErrorMessage(error);
    } finally {
      commit(types.SET_KNOWLEDGE_BASE_DOCUMENT_UI_FLAG, { isApproving: false });
    }
  },
};

export const mutations = {
  [types.SET_KNOWLEDGE_BASE_DOCUMENT_UI_FLAG]($state, data) {
    $state.uiFlags = {
      ...$state.uiFlags,
      ...data,
    };
  },
  [types.SET_KNOWLEDGE_BASE_DOCUMENTS]: MutationHelpers.set,
  [types.ADD_KNOWLEDGE_BASE_DOCUMENT]: MutationHelpers.setSingleRecord,
  [types.DELETE_KNOWLEDGE_BASE_DOCUMENT]: MutationHelpers.destroy,
};

export default {
  namespaced: true,
  actions,
  state,
  getters,
  mutations,
};
